<!-- =========================================================================================
  File Name: InstituteEdit.vue
  Description: Institute Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-institute-edit">

    <vs-alert color="danger" title="Institute Not Found" :active.sync="institute_not_found">
      <span>Institute record with id: {{ $route.params.instituteSeq }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'page-institute-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <!-- <vx-card v-if="institute_data"> -->
    <vx-card title="학원 상세 정보" class="mb-base" v-if="institute_data">
      <institute-edit-form class="mt-4" :data="institute_data" />

    </vx-card>
  </div>
</template>


<script>
import InstituteEditForm  from './InstituteEditForm.vue'
import { fetchData } from '@/api/module'

export default {
  components: {
    InstituteEditForm
  },
  data () {
    return {
      // instituteSeq: this.$route.params.instituteSeq,
      institute_data: null,
      institute_not_found: false
    }
  },
  methods: {
  },
  async created () {
    try {
      const instituteSeq = this.$route.params.instituteSeq
      const { data } = await fetchData(`institute/${instituteSeq}`)
      // console.log(data);
      this.institute_data = data.data
      
    } catch (error) {

      this.$vs.notify({
        title: 'Error',
        text: error.response.data.msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      }) 
    }
  }
  
}

</script>
